import React from "react";
import { FormattedMessage } from "react-intl";

const LOCATION_UNIT = "km";
export interface LocationRangeProps {
  from?: string;
  to?: string;
}

const LocationRange: React.FC<LocationRangeProps> = ({ from, to }) => {
  const renderContent = () => {
    if (from && to) {
      return (
        <FormattedMessage
          defaultMessage="{fromValue} {fromUnit} to {toValue} {toUnit}"
          description="location"
          values={{
            fromUnit: LOCATION_UNIT,
            fromValue: from,
            toUnit: LOCATION_UNIT,
            toValue: to
          }}
        />
      );
    }

    if (from && !to) {
      return (
        <FormattedMessage
          defaultMessage="from {value} {unit}"
          description="location from"
          values={{
            unit: LOCATION_UNIT,
            value: from
          }}
        />
      );
    }

    if (!from && to) {
      return (
        <FormattedMessage
          defaultMessage="to {value} {unit}"
          description="location to"
          values={{
            unit: LOCATION_UNIT,
            value: to
          }}
        />
      );
    }

    return <span>-</span>;
  };

  return renderContent();
};

LocationRange.displayName = "LocationRange";
export default LocationRange;
